import { useIsDisabled } from './helpers.js'

import View from './view.js'

export default function Logic(props) {
  let disabled = useIsDisabled(props)

  return <View {...props} disabled={disabled} />
}
